export default __webpack_public_path__ + "static/media/downloadIcon.9ced861b.svg";